/**
 * Le lien d'une notification ou d'une tâche ENREGISTRÉE, sous la forme que manient les écrans
 * (`LinkedEntityValue`) — une seule lecture des colonnes `linked_entity_*`.
 *
 * Lu par la modale de détail (valeur de départ du sélecteur de fiche liée) et par les deux
 * gestes de transfert (`TransferDialog`, `QuickTransferItems`) : le serveur juge le destinataire
 * d'un transfert sur le lien ENREGISTRÉ de la tâche — liée à un AO, il doit en voir l'entité
 * (décision PO n° 66) — et `useDestinatairesDeLaTache` borne la liste sur ce même lien.
 *
 * Le libellé et l'URL viennent de l'action de la notification ; l'URL, à défaut, du registre de
 * la recherche (`linkedEntityHref`, repli des données sans `actions`).
 */

import type { Notification } from '@/hooks/useNotifications.types'
import { linkedEntityHref, type LinkedEntityValue } from '@/lib/linkedEntity'

type AvecUnLien = Pick<Notification, 'linked_entity_type' | 'linked_entity_id' | 'actions'>

/** Le lien enregistré de `n`, ou `null` (aucune notification, ou pas de fiche liée). */
export function lienDeLaNotification(n: AvecUnLien | null | undefined): LinkedEntityValue | null {
    if (!n?.linked_entity_type || !n.linked_entity_id) return null
    const action = n.actions?.[0]
    return {
        type: n.linked_entity_type,
        id: n.linked_entity_id,
        label: action?.label ?? '',
        href: action?.href ?? linkedEntityHref(n.linked_entity_type, n.linked_entity_id) ?? '',
    }
}
